module.exports = __webpack_public_path__ + "img/icon-remove-light.7fd4828f.svg";